import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-834263be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-header" }



interface IProps {
  text: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ListHeader',
  props: {
    text: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.text), 1))
}
}

})